import formModel from './formModel';

const moment = require('moment');

const {
    formField: {
        //POLIZA
        fechaEmision,
        comentariosSolicitud,
        ajusteAutomatico,
        frecuenciaPago,
        cuotas,
        vigenciaDesde,
        vigenciaHasta,
        formaDePago,
        moduloCobertura,
        numeroTramite,
        numeroPoliza,
        numeroReferencia,
        premium,
        //CLIENTE
        cliente: {
            rol,
            sexo,
            fechaNacimiento,
            dni,
            cuit,
            telefono,
            codigoArea,
            domicilio,
            estadoCivil,
            apellido,
            codigosLocalidad,
            email,
            personaJuridica,
            actividadPrincipal,
            categoriaMonotributo,
            lugarNacimiento,
            nombre,
            situacionIva
        },
        emailDespachoElectronico,
        descuentoCliente,
        //VEHICULO
        outStandardSancor,
        vehiculo: {
            patente,
            chasis,
            motor,
            marca,
            modelo,
            anio,
            tipoUso,
            valor,
            tieneGnc,
            ceroKm,
            equipoDeRastreo,
            inspeccionPrevia: {
                comentariosInspeccion,
                fechaInspeccion,
                tipoCombustible,
                aspectoGeneral,
                estadoCristales,
                resultadoInspeccion,
                kilometraje,
                aspectoPintura,
                tipoPintura,
                aspectoChapa,
                aspectoNeumaticos,
                aspectoTapizado,
                colorTapizado,
                tipoTapizado,
                colorVehiculo,
                tipoLlantas,
            },
            gnc: {
                valorTotal,
                cilindros: {
                    marcaCilindro,
                    numeroCilindro
                },
                marcaRegulador,
                numeroRegulador,
            },
        },
        bienesAsegurados: {
            id,
            descripcion,
            suma,
        },
    }
} = formModel;

export default {
    //PÓLIZA
    [fechaEmision.name]: moment().format('YYYY-MM-DD'),
    [vigenciaDesde.name]: moment().format('YYYY-MM-DD'),
    [vigenciaHasta.name]: moment().add(1, "Y").format("YYYY-MM-DD"),
    [formaDePago.name]: '0',
    [frecuenciaPago.name]: '5',
    [emailDespachoElectronico.name]: '',
    [comentariosSolicitud.name]: '',
    [moduloCobertura.name]: '',
    [premium.name]: '',
    [numeroTramite.name]: '',
    [numeroPoliza.name]: '',
    [numeroReferencia.name]: '',
    [cuotas.name]: '',
    [ajusteAutomatico.name]: '',
    [descuentoCliente.name]: '',
    //CLIENTE
    clientes: [
        {
            [rol.name]: '2',
            [personaJuridica.name]: '0',
            [dni.name]: '',
            [cuit.name]: '',
            [nombre.name]: '',
            [apellido.name]: '',
            [fechaNacimiento.name]: '',
            [estadoCivil.name]: '2',
            [sexo.name]: '',
            [domicilio.name]: '',
            [codigosLocalidad.name]: '',
            [codigoArea.name]: '',
            [telefono.name]: '',
            [email.name]: '',
            [situacionIva.name]: '4',
            [categoriaMonotributo.name]: '1',
            [actividadPrincipal.name]: '10001',
            [lugarNacimiento.name]: 'Cordoba'
        },
    ],
    //VEHICULO
    [outStandardSancor.name]: "false",
    vehiculo: {
        [patente.name]: '',
        [motor.name]: '',
        [chasis.name]: '',
        [marca.name]: '',
        [modelo.name]: '',
        [anio.name]: '',
        [tipoUso.name]: '2',
        [valor.name]: '',
        [tieneGnc.name]: '',
        [ceroKm.name]: 'false',
        [equipoDeRastreo.name]: '',
        gnc: {
            [marcaRegulador.name]: '',
            [numeroRegulador.name]: '',
            cilindros: [
                {
                    [marcaCilindro.name]: '',
                    [numeroCilindro.name]: '',
                },
            ],
            [valorTotal.name]: '',
        },
        inspeccionPrevia: {
            [fechaInspeccion.name]: moment().format('YYYY-MM-DD'),
            [tipoCombustible.name]: '1',
            [comentariosInspeccion.name]: '',
            [aspectoGeneral.name]: '2',
            [estadoCristales.name]: 'SinProblemas',
            [resultadoInspeccion.name]: '1',
            [kilometraje.name]: '15000',
            [aspectoPintura.name]: '2',
            [tipoPintura.name]: '2',
            [aspectoChapa.name]: '2',
            [aspectoNeumaticos.name]: '2',
            [aspectoTapizado.name]: '2',
            [colorTapizado.name]: '13',
            [tipoTapizado.name]: '2',
            [colorVehiculo.name]: 'A declarar',
            [tipoLlantas.name]: '2',
            archivos: []
        },
    },
    bienesAsegurados: [
        {
            [id.name]: '10',
            [descripcion.name]: '',
            [suma.name]: '',

        }
    ],
};
